/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AcknowledgementText from './AcknowledgementText/index'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderLocation/PlatformFeeWarning/Content",
  onChange,
  amount
  
}) {
let paymentIsFeeAcknowledgedValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'is_fee_acknowledged',
})
let paymentIsFeeAcknowledgedChangeData = fromData.useDataChange({ viewPath,
context: 'payment',
path: 'is_fee_acknowledged',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="payment.is_fee_acknowledged"
 value={paymentIsFeeAcknowledgedValueData}
 onChange={paymentIsFeeAcknowledgedChangeData}
 size="small"
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 alignSelf="flex-start"
 marginTop={dtSpaceXxxs}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mr-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<AcknowledgementText
  viewPath={`${viewPath}/AcknowledgementText`}
 amount={amount}
/>
</div>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}